<template>
  <div class="poem">
    <!-- 输入框 -->
    <el-input v-model="title" placeholder="题目" style="width:15%"></el-input>
    <el-input v-model="author" placeholder="作者" style="width:15%"></el-input>
    <el-button type="primary" @click="handleSearch">搜索</el-button>
    <el-divider></el-divider>
    <el-table
        :data="tableData"
        stripe
        v-loading.fullscreen.lock="fullscreenLoading"
    >
        <el-table-column label="名字" prop="title" width="420"> </el-table-column>
        <el-table-column label="作者" prop="author" width="100"> </el-table-column>
        <el-table-column label="朝代" prop="dynasty" width="100"> </el-table-column>
        <el-table-column label="字数 （点击右侧箭头查看全文）" prop="content.length" width="300"> </el-table-column>
        <el-table-column type="expand">
        <template slot-scope="props">
            <el-form inline class="demo-table-expand">
            <el-form-item label=""> <span>{{ props.row.content }}</span> </el-form-item>
            </el-form>
        </template>
        </el-table-column>
    </el-table>
    <el-divider></el-divider>
    <!-- 分页码器 -->
    <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        class="pagination"
        @current-change="changePage"
    >
    </el-pagination>
  </div>
</template>

<script>
import axios from 'axios'
import surl from '@/common'
export default {
  name: 'Poem',
  data () {
    return {
      fullscreenLoading: true,
      tableData: [],
      page: 0,
      perPage: 10,
      total: 0,
      author: '',
      title: ''
    }
  },
  methods: {
    handlePoem (res) {
      var dt = res.data.data
      console.log(dt)
      this.tableData = dt.poems
      this.page = dt.page
      this.perPage = dt.per_page || 10
      this.total = dt.total
      this.fullscreenLoading = false
    },
    changePage (pageNum) {
      this.fullscreenLoading = true
      if (this.author === '' && this.title === '') {
        var url = surl.PROD_URL + '/v1/poems?order_by=id:0&page=' + pageNum
      } else {
        url = surl.PROD_URL + '/v1/poems?order_by=id:0&page=' + pageNum + '&filter_by=author:$like:' + this.author + '|title:$like:' + this.title
        console.log(url)
      }
      axios.get(url)
        .then(this.handlePoem)
    },
    handleSearch () {
      this.fullscreenLoading = true
      if (this.author === '' && this.title === '') {
        this.$confirm('请输入有效的诗词名字或者作者')
      } else {
        let url = surl.PROD_URL + '/v1/poems?order_by=id:0&filter_by=author:$like:' + this.author + '|title:$like:' + this.title
        console.log(url)
        axios.get(url)
          .then(this.handlePoem)
      }
    }
  },
  mounted: function () {
    axios.get(surl.PROD_URL + '/v1/poems?order_by=id:0')
      .then(this.handlePoem)
  }
}
</script>

<style scoped>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 180px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }
  .poem {
    width: -moz-fit-content;
    width: -webkit-fit-content;
    width: 70%;
    margin: 30px auto;
  }
  .pagination {
    width: -moz-fit-content;
    width: -webkit-fit-content;
    margin: 20px auto;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Poem/Poem.vue